import React, { useEffect, useState } from "react";
import { getGeneralLedgerNumbers } from "../../config/services/GeneralLedgerService";

export type ReconTxn = {
  id: number;
  accountNumber: string;
  drcr: string;
  amount: number;
  postDate: string;
};
interface Props {
  isOpen: boolean;
  reconRefNo: string;
  transactions: ReconTxn[];
  onClose: () => void;
  onSave: (updated: ReconTxn[]) => Promise<void>;
}

const EditJournalModal: React.FC<Props> = ({
  isOpen,
  reconRefNo,
  transactions,
  onClose,
  onSave,
}) => {
  const [rows, setRows] = useState<ReconTxn[]>([]);
  type EditColumn<T> = {
    label: string;
    key: keyof T;
  };
  const editColumns: EditColumn<ReconTxn>[] = [
    { label: "Account", key: "accountNumber" },
    { label: "DR / CR", key: "drcr" },
    { label: "Amount", key: "amount" },
    { label: "Post Date", key: "postDate" },
  ];

  useEffect(() => {
    if (isOpen) {
      setRows(transactions);
    }
  }, [isOpen, transactions]);

  const updateRow = (
    id: number,
    field: keyof ReconTxn,
    value: string | number,
  ) => {
    setRows((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [field]: value } : r)),
    );
  };
  const [glNumbers, setGlNumbers] = useState<string[]>([]);
  useEffect(() => {
    const loadGLs = async () => {
      try {
        const gls = await getGeneralLedgerNumbers();
        setGlNumbers(gls);
      } catch (err) {
        console.error("Failed to load GL numbers", err);
      }
    };

    loadGLs();
  }, []);
  const drRows = rows.filter((r) => r.drcr === "DR");
  const crRows = rows.filter((r) => r.drcr === "CR");

  const totalDR = drRows.reduce((sum, r) => sum + r.amount, 0);
  const totalCR = crRows.reduce((sum, r) => sum + r.amount, 0);

  const hasAtLeastOneDR = drRows.length > 0;
  const hasAtLeastOneCR = crRows.length > 0;

  const isBalanced = totalDR === totalCR;
  const isValidJournal = hasAtLeastOneDR && hasAtLeastOneCR && isBalanced;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-[900px] rounded-lg shadow-lg">
        {/* HEADER */}
        <div className="px-6 py-4 border-b">
          <h2 className="text-lg font-semibold">
            Edit Journal Entries – {reconRefNo}
          </h2>
        </div>

        {/* BODY */}
        <div className="p-6 max-h-[60vh] overflow-auto">
          <table className="w-full text-sm border">
            {/* <thead className="bg-gray-100">
              <tr>
                <th className="px-3 py-2">Account</th>
                <th className="px-3 py-2">DR / CR</th>
                <th className="px-3 py-2 text-right">Amount</th>
                <th className="px-3 py-2">Post Date</th>
              </tr>
            </thead> */}
            <thead className="bg-gray-100">
              <tr>
                {editColumns.map((col) => (
                  <th key={col.key as string} className="px-3 py-2">
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            {/* <tbody>
              {rows.map((txn) => (
                <tr key={txn.id} className="border-t">
                  <td className="px-3 py-2 align-top">
                    {txn.drcr === "CR" ? (
                      <select
                        value={txn.accountNumber}
                        onChange={(e) => {
                          updateRow(txn.id, "accountNumber", e.target.value);

                          e.currentTarget.size = 1;
                          e.currentTarget.blur();
                        }}
                        onFocus={(e) => (e.currentTarget.size = 6)}
                        onBlur={(e) => (e.currentTarget.size = 1)}
                        size={1}
                        className="border px-2 py-1 w-[200px] rounded
    focus:outline-none focus:ring-1 focus:ring-blue-500"
                      >
                        <option value="">Select GL</option>
                        {glNumbers.map((gl) => (
                          <option key={gl} value={gl}>
                            {gl}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        value={txn.accountNumber}
                        onChange={(e) =>
                          updateRow(txn.id, "accountNumber", e.target.value)
                        }
                        className="border px-2 py-1 w-[200px] rounded
        focus:outline-none focus:ring-1 focus:ring-blue-500"
                      />
                    )}
                  </td>

                  <td className="px-3 py-2">
                    <select
                      value={txn.drcr}
                      onChange={(e) =>
                        updateRow(txn.id, "drcr", e.target.value as any)
                      }
                      className="border px-2 py-1"
                    >
                      <option value="DR">DR</option>
                      <option value="CR">CR</option>
                    </select>
                  </td>

                  <td className="px-3 py-2 text-right">
                    <input
                      type="number"
                      value={txn.amount}
                      onChange={(e) =>
                        updateRow(txn.id, "amount", Number(e.target.value))
                      }
                      className="border px-2 py-1 w-28 text-right"
                    />
                  </td>

                  <td className="px-3 py-2">
                    <input
                      type="date"
                      value={txn.postDate}
                      onChange={(e) =>
                        updateRow(txn.id, "postDate", e.target.value)
                      }
                      className="border px-2 py-1"
                    />
                  </td>
                </tr>
              ))}
            </tbody> */}
            <tbody>
  {rows.map((txn) => (
    <tr key={txn.id} className="border-t">
      {editColumns.map((col) => {
        switch (col.key) {
          case "accountNumber":
            return (
              <td key={col.key} className="px-3 py-2">
                {txn.drcr === "DR" ? (
                  <select
                    value={txn.accountNumber}
                    onChange={(e) =>
                      updateRow(txn.id, "accountNumber", e.target.value)
                    }
                    className="border px-2 py-1 w-[200px]"
                  >
                    <option value="">Select GL</option>
                    {glNumbers.map(([gl,role]) => (
                                      <option key={`${gl}-${role}`} value={gl}>
                                        {role}
                                      </option>
                                    ))}
                  </select>
                ) : (
                  <input
                    value={txn.accountNumber}
                    onChange={(e) =>
                      updateRow(txn.id, "accountNumber", e.target.value)
                    }   
                    className="border px-2 py-1 w-[200px]"
                  />
                )}
              </td>
            );

          case "drcr":
            return (
              <td key={col.key} className="px-3 py-2">
                <select
                  value={txn.drcr}
                  onChange={(e) =>
                    updateRow(txn.id, "drcr", e.target.value as any)
                  }
                  className="border px-2 py-1"
                >
                  <option value="DR">DR</option>
                  <option value="CR">CR</option>
                </select>
              </td>
            );

          case "amount":
            return (
              <td key={col.key} className="px-3 py-2 text-right">
                <input
                  type="number"
                  value={txn.amount}
                  onChange={(e) =>
                    updateRow(txn.id, "amount", Number(e.target.value))
                  }
                  className="border px-2 py-1 w-28 text-right"
                />
              </td>
            );

          case "postDate":
            return (
              <td key={col.key} className="px-3 py-2">
                <input
                  type="date"
                  value={txn.postDate}
                  onChange={(e) =>
                    updateRow(txn.id, "postDate", e.target.value)
                  }
                  className="border px-2 py-1"
                />
              </td>
            );

          default:
            return null;
        }
      })}
    </tr>
  ))}
</tbody>
          </table>
        </div>

        {/* FOOTER */}
        <div className="px-6 py-4 border-t flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 border rounded">
            Cancel
          </button>
          <button
            onClick={() => onSave(rows)}
            disabled={!isValidJournal}
            className={`px-6 py-2 rounded text-white ${
              isValidJournal ? "bg-blue-600" : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            Save All
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditJournalModal;
